export const THREE_STATE_SCORING_TABLE = {
    'Piek': {
        // 4 players active (all participate)
        4: {
            0: { loser: -15, neutral: -15 },  // All fail
            1: { winner: 45, loser: -15, neutral: -15 },  // 1 succeeds, 3 fail
            2: { winner: 30, loser: -30, neutral: -30 },  // 2 succeed, 2 fail  
            3: { winner: 15, loser: -45, neutral: -45 },  // 3 succeed, 1 fails
            4: { winner: 0, loser: 0, neutral: 0 }  // All succeed (shouldn't happen)
        },
        // 3 players active
        3: {
            0: { loser: -15, neutral: 45 },
            1: { winner: 45, loser: -30, neutral: 15 },
            2: { winner: 30, loser: -45, neutral: -15 },
            3: { winner: 15, neutral: -45 }
        },
        // 2 players active
        2: {
            0: { loser: -30, neutral: 30 },
            1: { winner: 45, loser: -45, neutral: 0 },
            2: { winner: 30, neutral: -30 }
        },
        // 1 player active
        1: {
            1: { winner: 45, neutral: -15 },
            0: { loser: -45, neutral: 15 }
        }
    },
    'Misère': {
        // 4 players active
        4: {
            0: { loser: -25, neutral: -25 },
            1: { winner: 75, loser: -25, neutral: -25 },
            2: { winner: 50, loser: -50, neutral: -50 },
            3: { winner: 25, loser: -75, neutral: -75 },
            4: { winner: 0, loser: 0, neutral: 0 }
        },
        // 3 players active
        3: {
            0: { loser: -25, neutral: 75 },
            1: { winner: 75, loser: -50, neutral: 25 },
            2: { winner: 50, loser: -75, neutral: -25 },
            3: { winner: 25, neutral: -75 }
        },
        // 2 players active
        2: {
            0: { loser: -50, neutral: 50 },
            1: { winner: 75, loser: -75, neutral: 0 },
            2: { winner: 50, neutral: -50 }
        },
        // 1 player active
        1: {
            1: { winner: 75, neutral: -25 },
            0: { loser: -75, neutral: 25 }
        }
    },
    'Open piek': {
        // 4 players active
        4: {
            0: { loser: -40, neutral: -40 },
            1: { winner: 120, loser: -40, neutral: -40 },
            2: { winner: 80, loser: -80, neutral: -80 },
            3: { winner: 40, loser: -120, neutral: -120 },
            4: { winner: 0, loser: 0, neutral: 0 }
        },
        // 3 players active
        3: {
            0: { loser: -40, neutral: 120 },
            1: { winner: 120, loser: -80, neutral: 40 },
            2: { winner: 80, loser: -120, neutral: -40 },
            3: { winner: 40, neutral: -120 }
        },
        // 2 players active
        2: {
            0: { loser: -80, neutral: 80 },
            1: { winner: 120, loser: -120, neutral: 0 },
            2: { winner: 80, neutral: -80 }
        },
        // 1 player active
        1: {
            1: { winner: 120, neutral: -40 },
            0: { loser: -120, neutral: 40 }
        }
    },
    'Open misère': {
        // 4 players active
        4: {
            0: { loser: -50, neutral: -50 },
            1: { winner: 150, loser: -50, neutral: -50 },
            2: { winner: 100, loser: -100, neutral: -100 },
            3: { winner: 50, loser: -150, neutral: -150 },
            4: { winner: 0, loser: 0, neutral: 0 }
        },
        // 3 players active
        3: {
            0: { loser: -50, neutral: 150 },
            1: { winner: 150, loser: -100, neutral: 50 },
            2: { winner: 100, loser: -150, neutral: -50 },
            3: { winner: 50, neutral: -150 }
        },
        // 2 players active
        2: {
            0: { loser: -100, neutral: 100 },
            1: { winner: 150, loser: -150, neutral: 0 },
            2: { winner: 100, neutral: -100 }
        },
        // 1 player active
        1: {
            1: { winner: 150, neutral: -50 },
            0: { loser: -150, neutral: 50 }
        }
    },
    'Open piek met een praatje': {
        // 4 players active
        4: {
            0: { loser: -55, neutral: -55 },
            1: { winner: 165, loser: -55, neutral: -55 },
            2: { winner: 110, loser: -110, neutral: -110 },
            3: { winner: 55, loser: -165, neutral: -165 },
            4: { winner: 0, loser: 0, neutral: 0 }
        },
        // 3 players active
        3: {
            0: { loser: -55, neutral: 165 },
            1: { winner: 165, loser: -110, neutral: 55 },
            2: { winner: 110, loser: -165, neutral: -55 },
            3: { winner: 55, neutral: -165 }
        },
        // 2 players active
        2: {
            0: { loser: -110, neutral: 110 },
            1: { winner: 165, loser: -165, neutral: 0 },
            2: { winner: 110, neutral: -110 }
        },
        // 1 player active
        1: {
            1: { winner: 165, neutral: -55 },
            0: { loser: -165, neutral: 55 }
        }
    },
    'Open misère met een praatje': {
        // 4 players active
        4: {
            0: { loser: -60, neutral: -60 },
            1: { winner: 180, loser: -60, neutral: -60 },
            2: { winner: 120, loser: -120, neutral: -120 },
            3: { winner: 60, loser: -180, neutral: -180 },
            4: { winner: 0, loser: 0, neutral: 0 }
        },
        // 3 players active
        3: {
            0: { loser: -60, neutral: 180 },
            1: { winner: 180, loser: -120, neutral: 60 },
            2: { winner: 120, loser: -180, neutral: -60 },
            3: { winner: 60, neutral: -180 }
        },
        // 2 players active
        2: {
            0: { loser: -120, neutral: 120 },
            1: { winner: 180, loser: -180, neutral: 0 },
            2: { winner: 120, neutral: -120 }
        },
        // 1 player active
        1: {
            1: { winner: 180, neutral: -60 },
            0: { loser: -180, neutral: 60 }
        }
    }
};
